import { render, staticRenderFns } from "./Unidad.vue?vue&type=template&id=4bc4dabb&scoped=true&"
import script from "./Unidad.vue?vue&type=script&lang=js&"
export * from "./Unidad.vue?vue&type=script&lang=js&"
import style0 from "./Unidad.vue?vue&type=style&index=0&id=4bc4dabb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc4dabb",
  null
  
)

export default component.exports